<template>
	<!-- BEGIN login -->
	<div class="login login-with-news-feed">
		<!-- BEGIN news-feed -->
		<div class="news-feed">
			<div class="news-image"><img src="./../images/loginbg.jpg" style="width: 100%; height: 100%;" alt="" /></div>
			<div class="news-caption"><h4 class="caption-title">湖南高铁时代综合实训管理平台</h4></div>
		</div>
		<!-- END news-feed -->

		<!-- BEGIN login-container -->
		<div class="login-container">
			<!-- BEGIN login-header -->
			<div class="login-header mb-30px">
				<div class="brand">
					<div class="d-flex align-items-center" style="color: #000;">
						<img src="../images/logo2.png" alt="" width="40px" height="32px" />

						<b style="margin-left: 10px;">登录</b>
					</div>
					<small style="color: #1c0803;font-weight: 700;">湖南高铁时代综合实训室管理平台登录</small>
				</div>
				<div class="icon"><i class="fa fa-sign-in-alt"></i></div>
			</div>
			<!-- END login-header -->

			<!-- BEGIN login-content -->
			<div class="login-content">
				<form class="fs-13px">
					<div class="form-floating mb-15px">
						<input
							v-on:keyup.13="opensldeverfy"
							@input="logininput()"
							type="text"
							v-model="userdata.ui_userName"
							class="form-control h-45px fs-13px"
							placeholder="账号"
							id="emailAddress"
							:style="{ 'border-color': showmassage == 1 ? 'red' : '' }"
							maxlength="20"
						/>
						<!-- readonly="readonly" -->
						<label for="emailAddress" class="d-flex align-items-center fs-13px text-gray-600">账号</label>
					</div>
					<div class="form-floating mb-15px">
						<input
							v-on:keyup.13="opensldeverfy()"
							@input="loginpassword()"
							:type="type"
							v-model="userdata.ui_password"
							maxlength="20"
							class="form-control h-45px fs-13px"
							placeholder="密码"
							id="password"
							:style="{ 'border-color': showmassage == 2 ? 'red' : '' }"
						/>
						<!-- readonly="readonly" -->
						<i class="iconshow" @click="flags = !flags" :class="userdata.ui_password ? elIcons : ''"></i>
						<label for="password" class="d-flex align-items-center fs-13px text-gray-600">密码</label>
					</div>
					<div class="form-check mb-30px">
						<input @change="changepassard" v-model="ridov" class="form-check-input" type="checkbox" value="1" id="rememberMe" />
						<label class="form-check-label" for="rememberMe">记住密码</label>
					</div>

					<div class="mb-15px">
						<button
							type="button"
								@click="opensldeverfy"
							v-preventReClick
							style="letter-spacing: 10px;font-weight: 600;"
							class="btn btn-success d-block h-45px w-100 btn-lg fs-18px"
						>
							登录
						</button>
					</div>
					<div style="height: 40px;display: flex;align-items: center;justify-content: space-between;">
						<!-- pb-40px -->
						<div class="mb-40px  text-dark">
							没有账号? 点击
							<router-link to="/user/register" class="text-success">这里</router-link>
							去注册.
						</div>
						<div class="mb-40px  text-dark"><router-link to="/user/foundpass" class="text-success">忘记密码</router-link></div>
					</div>
					<div style="width: 100%; display: flex;align-items: center;justify-content: center;">
						<div @click="fecces()" style="margin: 0 20px; cursor: pointer;flex-direction: column;display: flex;align-items: center;justify-content: center;">
							<img class="w-40px h-40px " src="@/assets/img/faces.svg" alt="" />
							人脸登录
						</div>
						<div @click="gourl()" style="margin: 0 20px;cursor: pointer;flex-direction: column;display: flex;align-items: center;justify-content: center;">
							<img class="w-40px h-40px " src="@/assets/img/inits.svg" alt="" />
							回引导页
						</div>
					</div>
					<hr class="bg-gray-600 opacity-2" />
					<div class="text-gray-600 text-center text-gray-500-darker mb-0">&copy; 实训后台管理系统 {{ new Date().getFullYear() }}</div>
				</form>
			</div>
			<!-- END login-content -->
		</div>
		<!-- END login-container -->

		<el-dialog
			title=""
			custom-class="sldeverfyclass"
			:show-close="false"
			destroy-on-close
			append-to-body
			center
			width="300px"
			top="35vh"
			:visible.sync="sldeverfyVisible"
			modal-append-to-body
			:before-close="handleClose"
		>
			<!-- 滑块验证 -->
			<div style="width: 100%;display: flex;align-items: center;justify-content: center;">
				<Captcha
					ref="dialogopen"
					:l="42"
					:r="10"
					:w="catcha.w"
					:h="catcha.h"
					:blocky="catcha.blocky"
					:imgurl="catcha.imgurl"
					:miniimgurl="catcha.miniimgurl"
					:slider-text="catcha.text"
					@success="onSuccess"
					@fail="onFail"
					@refresh="onRefresh"
				/>
			</div>
		</el-dialog>

		<el-dialog title="人脸识别" destroy-on-close append-to-body center :visible.sync="dialogVisible" modal-append-to-body :before-close="handleClose">
			<span style="color: red;">请将人脸在人脸置于框中（注：一次只能识别一个人）</span>
			<div style="display: flex;align-items: center;width: 100%;justify-content: center;" v-if="dialogVisible">
				<div style="position: relative;overflow: hidden;">
					<p style="width: 100%;text-align: center;color: #ccc;margin: 10px 0;font-size: 16px;">{{ relicts }}</p>
					<video id="video" style="transform:rotateY(180deg);width: 200px;height: 200px;border-radius: 50%;" autoplay></video>
					<div class="saomiao"></div>
				</div>
				<div style="display: none;"><canvas id="canvas" width="400" height="400" style="transform:rotateY(180deg)"></canvas></div>
			</div>
		</el-dialog>
	</div>
	<!-- END login -->
</template>

<style>
.sldeverfyclass .el-dialog__header {
	display: none;
}

.sldeverfyclass .el-dialog__body {
	padding: 5px !important;
	width: 300px;
}
</style>

<style scoped lang="less">
/* .logo{
        background-image: url("../images/logo2.png") !important;
    } */

.iconshow {
	position: absolute;
	display: block;
	color: #ccc;
	font-size: 1rem;
	width: 1vw;
	height: 1vw;
	top: 40%;
	right: 6%;
}
.saomiao {
	width: 75%;
	margin-top: 20%;
	height: 2px;
	background: linear-gradient(244deg, rgba(255, 255, 255, 0) 0%, #56dafe 50%, rgba(255, 255, 255, 0) 100%);
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	top: 0px;
	animation: move 6s ease-in-out infinite;
	-webkit-animation: move 6s ease-in-out infinite;
}
@keyframes move {
	from {
		top: 0px;
	}
	/*网格移动到显示区域的外面*/
	to {
		top: 100%;
	}
}
</style>

<script>
import AppOptions from '@/config/AppOptions.vue';
import { logins } from '@/request/api/login/login.js';
import { getUserSingle } from '@/request/api/mange/mange.js';
// import JSEncrypt from 'jsencrypt'
// import axios from "axios"

import { userMedia } from '../utils/utils';
require('tracking/build/tracking-min.js');
require('tracking/build/data/face-min.js');

import { FaceLoginuser, CheckCaptcha, GetCaptcha } from '@/request/api/homesview/yunhomes/yunhom.js';

import Captcha from '@/components/sldeverfyxg.vue';

export default {
	data() {
		return {
			flags: false,
			userdata: {
				ui_userName: '',
				ui_password: '',
				returnUrl: 'www.baidu.com/index',
				ul_deviceType: 'PC',
				ul_visitSystem: '实训平台'
			},
			ridov: true,
			showmassage: 0,
			menus: '',
			dialogVisible: false,
			saveArray: {},
			videoObj: null,
			trackerTask: null,
			relicts: '',
			isresolves: 1,
			isfeces: 0,
			loadings: null,
			sldeverfyVisible: false,
			catcha: {
				blocky: 0,
				imgurl: '',
				miniimgurl: '',
				text: '向右滑动完成拼图',
				h: 155,
				w: 300,
				sh: 62,
				sw: 155,
				modifyImg: ''
			} // 图片验证码传值
		};
	},
	created() {
		AppOptions.appEmpty = true;
	},
	components: {
		Captcha
	},
	// beforeRouteLeave(to, from, next) {
	// 	// AppOptions.appEmpty = false;
	// 	next();
	// },
	mounted() {
		

		if (this.$cookie.get('/%password/%')) {
			localStorage.setItem('/%password/%', this.$cookie.get('/%password/%'));
			localStorage.setItem('/%name/%', this.$cookie.get('/%name/%'));
		}
		let self = this;
		let pasd = localStorage.getItem('/%password/%');
		let name = localStorage.getItem('/%name/%');
		// console.log('获取账号密码', name, pasd);
		setTimeout(() => {
			self.ridov = self.$cookie.get('/%password/%') || localStorage.getItem('/%password/%') ? true : false;
			self.userdata.ui_userName = name ?? '';
			self.userdata.ui_password = pasd ?? '';
			localStorage.removeItem('userss');
			// console.log(self.userdata.ui_password, '获取用户名密码', self.userdata.ui_userName);
		}, 200);
		
		this.getimgse();
	},
	//使用computed
	computed: {
		type() {
			return this.flags ? 'text' : 'password';
		},
		elIcons() {
			return this.flags ? 'el-icon-view' : 'fa fa-eye-slash';
		}
	},
	watch: {
		dialogVisible(newVal, oldVal) {
			// console.log(newVal, oldVal, '改变');
			if (!newVal) {
				// console.log('停止播放');
				this.handleCancel();
			}
		}
	},
	methods: {
		// 获取滑动
		getimgse() {
			GetCaptcha().then(res => {
				// console.log(res.data.data, '获取');
				this.catcha.blocky = res.data.data.sliderXXXXX;
				this.catcha.imgurl = res.data.data.background;
				this.catcha.miniimgurl = res.data.data.slider;
				this.catcha.sessionId = res.data.data.sessionId;
				this.$nextTick(() => {
					if (this.$refs.dialogopen) {
						this.$refs.dialogopen.reset(res.data.data.sliderXXXXX);
					}
				});
			});
		},

		onSuccess(e) {
			// console.log(e);
			let lefts = e;
			let Checkobj = {
				sessionId: this.catcha.sessionId,
				x: lefts
			};
			CheckCaptcha(Checkobj).then(res => {
				// console.log(res.data.code);

				if (res.data.code == 1 || res.data.code == 0) {
					this.$refs.dialogopen.handleSuccess();
					this.$message.success('验证成功');
					setTimeout(() => {
						this.sldeverfyVisible = false;
						this.checkForm();
					}, 1000);
				} else {
					this.$refs.dialogopen.handleFail();
					this.$message(res.data.data);
					// this.$message.close()
					setTimeout(() => {
						this.getimgse();
					}, 500);
				}
			});
		},
		onFail(e) {
			console.log(e);
		},
		onRefresh() {
				this.getimgse();
		},

		gourl() {
			this.$router.push('/');
		},
		openFullScreen2() {
			this.loadings = this.$loading({
				lock: true,
				text: '正在识别人脸，请在右侧设备录入人脸',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
		},
		fecces() {
			this.isresolves = 1;
			let that = this;
			let url = window.myURL.URL1;

			// this.openFullScreen2();
			// that.$axios({
			// 	url: url + '/Hik/GetFaze', //请求的后台接口
			// 	method: 'get' //get请求方式
			// })
			// 	.then(response => {
			// 		//请求成功
			// 		that.loadings.close();
			// 		console.log(response.data);
			// 		this.fecelogins(response.data);
			// 	})
			// 	.catch(error => {
			// 		//请求失败、
			// 		console.log(error);
			// 		that.loadings.close();

			// 		this.$message('当前浏览器版本不支持访问电脑摄像头请切换浏览器！');
			// 	});

			if (navigator.getUserMedia === undefined) {
				navigator.mediaDevices = {};
				this.$message('当前浏览器版本不支持访问电脑摄像头请切换浏览器！');
			} else {
				navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
				// console.log("人脸识别",navigator)
				navigator.getUserMedia(
					{ video: true, audio: true },
					function onSuccess(stream) {
						// console.log('已点击允许,开启成功');
						that.dialogVisible = true;
						that.openCamera();
					},
					function onError(error) {
						// console.log('错误：', error);

						that.$message('用户已拒绝使用');
						that.dialogVisible = false;
					}
				);
			}
		},
		handleCancel() {
			this.videoObj.srcObject.getTracks()[0].stop();
			this.trackerTask.stop();
		},
		openCamera() {
			let that = this;
			// 有可能触发一些其他的按钮会重新获取
			this.$nextTick(() => {
				const canvas = document.getElementById('canvas');
				const context = canvas.getContext('2d');
				this.videoObj = document.getElementById('video');
				// eslint-disable-next-line no-undef
				const tracker = new tracking.ObjectTracker('face'); // 检测人脸
				tracker.setInitialScale(2);
				tracker.setStepSize(1.7);
				tracker.setEdgesDensity(0.1);

				// eslint-disable-next-line no-undef
				this.trackerTask = tracking.track('#video', tracker, { camera: true });

				const constraints = {
					video: { width: 200, height: 200 },
					audio: false
				};
				var faces = [];
				context.clearRect(0, 0, canvas.width, canvas.height);
				userMedia(constraints, this.success, this.error);
				// console.log(tracker.on,'这里检测到了嘛')
				tracker.on('track', event => {
					// console.log(event.data,"人脸")
					faces = event.data;
					if (event.data.length > 0 && event.data.length < 2) {
						// 说明检测到人脸了，此时就可以截取图片传递给后端
						// console.log(this.videoObj)
						// canvas 调用 toDataURL
						// console.log(event.data, '人脸');

						event.data.forEach(rect => {
							that.saveArray.x = rect.x;
							that.saveArray.y = rect.y;
							that.saveArray.width = rect.width;
							that.saveArray.height = rect.height;
						});
						if (event.data.length > 0) {
							setTimeout(() => {
								that.setPhotoInterval();
							}, 2000);
						}
					} else if (event.data.length >= 2) {
						that.$message('请保持摄像头只有一张人脸');
					} else {
						that.relicts = '请将人脸置于框中';
					}
				});
			});
		},
		fecelogins(bese) {
			var newString = bese.replace('data:image/png;base64,', '');
			// if(newString.length<400){
			// 	return
			// }
			let filess = {
				files: newString
			};
			// console.log("可以进来了",this.isresolves)
			this.handleCancel();
			// console.log(newString)
			// return;
			// console.log(bese.length>10000,"这里到了嘛",bese.length,this.isfeces)
			if (this.isfeces > 0) {
				return;
			}

			FaceLoginuser(filess)
				.then(res => {
					// console.log(res, '获取请求');

					if (res.data.code > 0) {
						this.isresolves = 0;
						this.isfeces += 1;
						// this.$cookie.set('/%password/%', this.userdata.ui_password);
						
						window.localStorage.setItem('token', res.data.data.token);
						let expers = 2 * 60 * 60 * 1000; // 定义一个两小时的毫秒数n
						if (window.myURL.domain == '') {
							// console.log("与为空")
							this.$cookie.set('Token', res.data.data.token, { expires: expers });
						} else {
							// console.log("与有值")
							this.$cookie.set('Token', res.data.data.token, { expires: expers, domain: window.myURL.domain, Path: '/' });
						}
						if (res.status && res.data.data.token) {
							getUserSingle(res.data.data.ui_guid).then(re => {
								// console.log(re, "获取当前用户")
								if (re.data.code == -1) {
									// console.log("无权限")
								} else {
									// console.log("有权限")
									let usercenter = {};
									usercenter = re.data.data;
									usercenter.ui_realName = re.data.data.ui_realName;
									usercenter.ui_photoPath = re.data.data.ui_photoPath;
									usercenter.UserMenuList = re.data.data.UserMenuList;
									// this.$cookie.set("usercenter",JSON.stringify(usercenter))
									localStorage.setItem('userss', JSON.stringify(re.data.data));
									window.localStorage.setItem('usercenter', JSON.stringify(usercenter));
									window.localStorage.setItem('uiguid', res.data.data.ui_guid);
									window.localStorage.setItem('siguid', res.data.data.si_guid);
									// console.log(re.data.data.UserMenuList[0].path, "获取当前用户")
									if (re.data.data.UserMenuList[0].path == '/usercenter') {
										this.$router.push(re.data.data.UserMenuList[0].children[0].path);
									} else {
										this.$router.push(re.data.data.UserMenuList[0].path);
									}
								}
							});
						}
					}
					if (res.data.code == -1) {
						this.handleCancel();
						this.isresolves = 0;
						this.dialogVisible = false;
						return;
					}
				})
				.catch(e => {
					console.log(e, '错误');
					this.isresolves = 0;
					this.dialogVisible = false;
				});
		},

		// 成功显示
		success(stream) {
			this.videoObj.srcObject = stream;
			this.videoObj.play();
		},
		// 失败抛出错误，可能用户电脑没有摄像头，或者摄像头权限没有打开
		error(error) {
			// 可以在这里面提示用户
			console.log(`访问用户媒体设备失败${error.name}, ${error.message}`);
		},

		setPhotoInterval() {
			// console.log('拍照', this.saveArray);
			let canvas = document.getElementById('canvas');
			let video = document.getElementById('video');
			let ctx = canvas.getContext('2d');
			ctx.clearRect(0, 0, canvas.width, canvas.height);
			ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

			if (this.isresolves == 1) {
				// console.log(this.isresolves)
				if (this.saveArray.x < 150 && this.saveArray.y < 150) {
					let imgUrl = this.saveAsPNG(document.getElementById('canvas'));
					// console.log('data.imgUrl', imgUrl);
					if (imgUrl.length > 10000) {
						this.fecelogins(imgUrl);
					}
				}
			}
		},
		saveAsPNG(c) {
			return c.toDataURL('image/png', 1);
		},
		handleClose(done) {
			done();
			// this.$confirm('确认关闭？')
			// 	.then(_ => {
					
			// 	})
			// 	.catch(_ => {});
		},
		getlogins() {
			if (this.$cookie.get('Token').indexOf('ui_guid') > 0) {
				// 如果cookie有token且有id就从外域拿
				let uiguid = this.$cookie
					.get('Token')
					.split('&')[1]
					.split('=')[1];

				getUserSingle(uiguid).then(re => {
					if (re.data.code == -2) {
						localStorage.clear();
						// this.$cookie.clear();
						return;
					}

					if (re.data.code == -1) {
						// console.log("无权限")
						this.$router.push('/user/logins');
					} else {
						let usercenter = {};
						usercenter = re.data.data;
						usercenter.ui_realName = re.data.data.ui_realName;
						usercenter.ui_photoPath = re.data.data.ui_photoPath;
						usercenter.UserMenuList = re.data.data.UserMenuList;
						let token = this.$cookie
							.get('Token')
							.split('&')[0]
							.split('=')[1];
						window.localStorage.setItem('usercenter', JSON.stringify(usercenter));
						// console.log(uiguid,"获取当前用户id")
						this.$store.commit('chanusercenter', usercenter);
						localStorage.setItem('userss', JSON.stringify(re.data.data));
						this.$cookie.set('usercenter', JSON.stringify(usercenter));
						window.localStorage.setItem('uiguid', uiguid);
						window.localStorage.setItem('siguid', re.data.data.si_guid);
						window.localStorage.setItem('token', token);
						let autohsbtnlist = [];
						re.data.data.UserMenuList.forEach(item => {
							item.icon = item.icon ?? '';
							if (item.children.length == 0) {
								delete item.children;
							} else {
								item.children.forEach(ite => {
									if (ite.children.length > 0) {
										ite.children.forEach(it => {
											autohsbtnlist.push(it);
										});
										delete ite.children;
									} else {
										delete ite.children;
									}
									ite.icon = ite.icon ?? '';
								});
							}
						});
						this.menus = re.data.data.UserMenuList;
						window.sessionStorage.setItem('allbtnlist', JSON.stringify(autohsbtnlist));
						this.$cookie.set('lookinmune', JSON.stringify(re.data.data.LockUserMenuList));
						localStorage.setItem("lookinmune",JSON.stringify(re.data.data.LockUserMenuList))
						// console.log("有权限")
						usercenter = re.data.data;
						usercenter.ui_realName = re.data.data.ui_realName;
						usercenter.ui_photoPath = re.data.data.ui_photoPath;
						usercenter.UserMenuList = re.data.data.UserMenuList;
						// this.$cookie.set("usercenter",JSON.stringify(usercenter))
						window.localStorage.setItem('usercenter', JSON.stringify(usercenter));
						window.localStorage.setItem('uiguid', re.data.data.ui_guid);
						window.localStorage.setItem('siguid', re.data.data.si_guid);
						// console.log(re.data.data.UserMenuList[0].path, "获取当前用户")
						if (re.data.data.UserMenuList[0].path == '/usercenter') {
							this.$router.push(re.data.data.UserMenuList[0].children[0].path);
						} else {
							this.$router.push(re.data.data.UserMenuList[0].path);
						}
					}
				});
			} else if (localStorage.getItem('uiguid') && localStorage.getItem('token')) {
				// console.log("如果cookie里面没有就是从自己拿")
				getUserSingle(localStorage.getItem('uiguid')).then(res => {
					if (res.data.code == -2) {
						localStorage.clear();
						// this.$cookie.clear();
						return;
					}

					if (res.data.code == -1) {
						this.$router.push('/user/logins');
						return;
					}

					let autohsbtnlist = [];
					if (res.data.data.UserMenuList && res.data.data.UserMenuList.length > 0) {
						res.data.data.UserMenuList.forEach(item => {
							item.icon = item.icon ?? '';
							if (item.children.length == 0) {
								delete item.children;
							} else {
								item.children.forEach(ite => {
									if (ite.children.length > 0) {
										ite.children.forEach(it => {
											autohsbtnlist.push(it);
										});
										delete ite.children;
									} else {
										delete ite.children;
									}
									ite.icon = ite.icon ?? '';
								});
							}
						});
						this.menus = res.data.data.UserMenuList;
					}

					window.sessionStorage.setItem('allbtnlist', JSON.stringify(autohsbtnlist));
					this.$cookie.set('lookinmune', JSON.stringify(res.data.data.LockUserMenuList));
					localStorage.setItem("lookinmune",JSON.stringify(res.data.data.LockUserMenuList))

					// console.log("有权限")
					let usercenter = {};
					usercenter.ui_realName = res.data.data.ui_realName;
					usercenter.ui_photoPath = res.data.data.ui_photoPath;
					usercenter.UserMenuList = res.data.data.UserMenuList;
					// this.$cookie.set("usercenter",JSON.stringify(usercenter))
					window.localStorage.setItem('usercenter', JSON.stringify(usercenter));
					window.localStorage.setItem('uiguid', res.data.data.ui_guid);
					window.localStorage.setItem('siguid', res.data.data.si_guid);
					// console.log(re.data.data.UserMenuList[0].path, "获取当前用户")
					if (res.data.data.UserMenuList[0].path == '/usercenter') {
						this.$router.push(res.data.data.UserMenuList[0].children[0].path);
					} else {
						this.$router.push(res.data.data.UserMenuList[0].path);
					}
				});
			} else {
			}
		},

		loginpassword() {
			if (this.userdata.ui_password !== '') {
				this.showmassage = 0;
			} else {
				this.showmassage = 2;
			}
		},

		// 更改密码默认消失
		logininput() {
			if (this.userdata.ui_userName !== '') {
				this.showmassage = 0;
			} else {
				this.showmassage = 1;
			}
		},

		// 记住密码
		changepassard() {
			// console.log(this.ridov,'是不是这里清空了')

			if (this.ridov) {
				if (this.userdata.ui_password && this.userdata.ui_userName) {
					this.$cookie.set('/%password/%', this.userdata.ui_password);
					this.$cookie.set('/%name/%', this.userdata.ui_userName);
				}
			} else {
				this.$cookie.remove('/%password/%');
				this.$cookie.remove('/%name/%');
				localStorage.removeItem('/%password/%');
				localStorage.removeItem('/%name/%');
			}
		},
		opensldeverfy() {
			if (this.userdata.ui_userName == '') {
				this.showmassage = 1;
			} else if (this.userdata.ui_password == '') {
				this.showmassage = 2;
			} else {
				this.sldeverfyVisible = true;
			}
		},

		checkForm: function() {
			if (this.userdata.ui_userName == '') {
				this.showmassage = 1;
			} else if (this.userdata.ui_password == '') {
				this.showmassage = 2;
			} else {
				logins(this.userdata)
					.then(res => {
						// console.log(res, "登录")
						setTimeout(() => {
							this.sldeverfyVisible = false;
						}, 1000);
						if (res.data.code == 1) {
							if (this.ridov) {
								this.$cookie.set('/%password/%', this.userdata.ui_password);
								this.$cookie.set('/%name/%', this.userdata.ui_userName);
								localStorage.setItem('/%password/%', this.userdata.ui_password);
								localStorage.setItem('/%name/%', this.userdata.ui_userName);
							}

							window.localStorage.setItem('token', res.data.data.token);
							let expers = 2 * 60 * 60 * 1000; // 定义一个两小时的毫秒数n
							if (window.myURL.domain == '') {
								// console.log("与为空")
								this.$cookie.set('Token', res.data.data.token, { expires: expers });
							} else {
								// console.log("与有值")
								this.$cookie.set('Token', res.data.data.token, { expires: expers, domain: window.myURL.domain, Path: '/' });
							}
							if (res.status && res.data.data.token) {
								getUserSingle(res.data.data.ui_guid).then(re => {
									// console.log(re, "获取当前用户")
									if (re.data.code == -1) {
										// console.log("无权限")
									} else {
										// console.log("有权限")
										let usercenter = {};
										usercenter.ui_realName = re.data.data.ui_realName;
										usercenter.ui_photoPath = re.data.data.ui_photoPath;
										usercenter.UserMenuList = re.data.data.UserMenuList;
										// this.$cookie.set("usercenter",JSON.stringify(usercenter))
										window.localStorage.setItem('usercenter', JSON.stringify(usercenter));
										window.localStorage.setItem('uiguid', res.data.data.ui_guid);
										window.localStorage.setItem('siguid', res.data.data.si_guid);
										// console.log(re.data.data.UserMenuList[0].path, "获取当前用户")
										// typepath == 1 课程   typepath == 2 资源  typepath == 3 试题
										// console.log(this.$route.query.typepath, '获取当前luyou');
										if (this.$route.query.typepath) {
											if (this.$route.query.typepath == 1) {
												this.$router.push('/cours/clouddetea?coguid=' + this.$route.query.coguid);
											} else if (this.$route.query.typepath == 2) {
												this.$router.push('/resource/resourcedetils?liguid=' + this.$route.query.liguid + '&size=' + this.$route.query.size);
												// console.log('资源');
											} else if (this.$route.query.typepath == 3) {
												this.$router.push('/homesview/trialballoon');
												// console.log('试题');
											}
										} else {
											if (re.data.data.UserMenuList[0].path == '/usercenter') {
												this.$router.push(re.data.data.UserMenuList[0].children[0].path);
											} else {
												this.$router.push(re.data.data.UserMenuList[0].path);
											}
										}
									}
								});
							}
						}
					})
					.catch(err => {
						this.$message('登录失败，请联系管理员');
						console.log(err, '登录报错');
					});
			}
		}
	}
};
</script>
